import { CapabilityCategory } from '@trimble/web3d-capabilities';
import { CapabilityCoordinatorBase } from './capability-coordinator-base';
import { CapabilityRegistry } from './capability-registry/capability-registry';

export class MarkupEscapeHandlerCoordinator extends CapabilityCoordinatorBase<CapabilityRegistry> {
  // Drawing line → ESC → 3d viewer exits measurement mode (sets active tool to selection - we can't control this)
  // → We need to deactivate MeasurementCapability here also to be consistent with the 3d viewer behavior.

  // Before, we listened to the active-tool-changed event and deactivated MeasurementCapability when the active tool changed.
  // We filtered only when the active tool changed to default (selection), but this didn't help - it had side effects,
  // because there is logic that sets the active tool to selection for other reasons, not only when toggling measurement tools.
  // so better is not to use active-tool-changed event for that reason.

  // By the way, the 3d viewer has point, line, and angle measurement tools which are set as the active tool,
  // but it does not have an alignment measurement tool — it was built on top of the PickingTool instead.

  private readonly onKeyDown = (e: KeyboardEvent): void => {
    if (e.key === 'Escape') {
      const capabilities = [
        ...this.registry.capabilities(),
        ...this.registry
          .paneContainers()
          .flatMap((container) => container.capabilities()),
      ];
      capabilities
        .filter((c) => c.category === CapabilityCategory.Markup && c.isActive())
        .forEach((c) => c.deactivate());
    }
  };

  constructor(registry: CapabilityRegistry) {
    super(registry);
    document.addEventListener('keydown', this.onKeyDown);
  }

  public cleanup(): Promise<void> {
    document.removeEventListener('keydown', this.onKeyDown);
    return Promise.resolve();
  }
}
